app.controller('appController',
  ['$rootScope', '$scope', '$location', '$sanitize', 'authHelper', 'SETTINGS',
    'portalHelper', 'CONSTANTS', '$interval', 'apiHelper', '$window', '$timeout',
    '$ngConfirm', 'storageService', 'persistentService', 'historyService', '$document',
    'maintenanceService', 'permissionsHelper', '$injector',
    function ($rootScope, $scope, $location, $sanitize, authHelper, SETTINGS,
      portalHelper, CONSTANTS, $interval, apiHelper, $window, $timeout,
      $ngConfirm, storageService, persistentService, historyService, $document,
      maintenanceService, permissionsHelper, $injector) {

      // RPR-6816: used to keep permission-gated markup out of the DOM until the
      // logged-in user's permissions are known. Without it every such element
      // renders on its "permission denied" branch until the details arrive --
      // which for a positive check (a menu item, a dashboard tile) is invisible,
      // but for a negated one (the <no-access> panels, disabled inputs) flashes
      // the wrong state instead. Only the admin shell's routed view is held back
      // wholesale; the single negated gate reachable elsewhere asks for itself.
      //
      // Order matters. The settled latch is checked FIRST, so once the details
      // have arrived the answer is true for good and an already-rendered view is
      // never torn back down.
      //
      // isPublicRoute() is re-read on every digest rather than sampled once,
      // because this controller sits on <body> and is therefore constructed once
      // per page load, not once per route. Latching it would hold the gate open
      // for the rest of the page's life after landing on /Help or /FAQs (both
      // real admin routes, with header links rendered outside the gate) -- an
      // in-app navigation from there to a permission-gated screen would then
      // render with permissions still unknown, reintroducing this very flash in
      // its inverted form: hasPermission() answers false while details are
      // pending, so an entitled admin gets a <no-access> panel that then
      // disappears. A public route may still be viewed with no session at all,
      // and a failed retrieval does not always redirect (see
      // authHelper.isLoggedIn), so it must keep opening the gate while the user
      // is genuinely on one.
      //
      // Defined ahead of the assignments below purely as ordering hygiene; it is
      // not a safety net, since a throw down there aborts linking for <body>
      // entirely and no child directive -- this gate included -- ever runs.
      $rootScope.is_session_ready = function () {
        return authHelper.hasUserDetailsRetrievalSettled() || !!authHelper.isPublicRoute();
      };

      $scope.authHelper = authHelper;
      $scope.is_impersonation = authHelper.isImpersonation();
      $scope.login_orig = authHelper.getLogin(true);
      $scope.login = authHelper.getLogin(false);
      $scope.shared_data = authHelper.getSharedData();
      $scope.inside_popup = $location.search().insidePopup;

      // This will throw the user on maitenance page, if maintenance is in progress
      maintenanceService.pollMaintenanceStatus();

      $rootScope.cleanText = function (text) {
        return $sanitize(text);
      };

      $scope.go_to_password_change = function () {
        window.location.href = apiHelper.getApiUrl() + '/auth/change-password/';
      };

      // clear session storage for login details on unload, to fetch
      // login details from server again on page refresh or load
      // before this change was facing issue of cached permission, during page refresh
      window.addEventListener('unload', authHelper.removeStaleLoginDetails);

      $rootScope.title_prefix = portalHelper.fix_undefined(SETTINGS.TITLE_PREFIX);
      $rootScope.title = portalHelper.fix_undefined(SETTINGS.TITLE_PREFIX) + ' Genesis Research Group';
      $rootScope.usersnap = portalHelper.fix_undefined(SETTINGS.USERSNAP);
      $scope.getUrl = portalHelper.getUrl;
      $scope.isLocalStorageSupported = storageService.isLocalStorageSupported;

      // Sharing constants across the global scope
      $rootScope.CONSTANTS = CONSTANTS;

      $rootScope.$on('$routeChangeSuccess', function(event, current, previous) {
        historyService.add_to_history(angular.copy($window.location.href), '');
      });

      // this needs to be a function so that it is evaluated afresh on each page
      $scope.is_print_preview = function () {
        return $location.path().indexOf('Preview/') !== -1;
      };

      $scope.go_to_auth_account = function () {
        window.location.href = apiHelper.getApiUrl() + '/auth/account/';
      };

      $scope.is_test_survey = function () {
        return $location.path().indexOf('TestSurvey/') !== -1;
      };

      $scope.hide_menu_bar = function () {
        return $rootScope.hide_menu_bar;
      };

      $scope.showImpersonationBar = function () {
        // we must use jquery functions only when include is loaded!
        // and if it's not loaded, this impersonation bar won't be shown!!

        if (authHelper.isImpersonation()) {
          $('#impersonation-banner').slideDown();
        }
      };

      // it is possible, that user is authenticated and still on login page
      // this happens when we hit url /login/#/Logout
      // so we check page explicitly
      const is_login_page = $window.location.pathname.indexOf('/login/') === 0;
      const is_impersonation = authHelper.isImpersonation();

      //
      // track idle users
      //
      const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minutes
      const COUNTDOWN_TIMEOUT = 120; // 120 seconds
      const INTERVAL_IN_SECONDS = 1; //Seconds

      $scope.timeout_idle = null;

      function cancelCountdown() {
        if ($scope.countdown_timer) {
          $interval.cancel($scope.countdown_timer);
          $scope.countdown_timer = null;
        }
      }

      function resetIdleTimeout(seconds_since_last_move) {
        if ($scope.timeout_idle) {
          $timeout.cancel($scope.timeout_idle);
        }

        if (seconds_since_last_move) {
          // eslint: (Recursive, so can't help it)
          // eslint-disable-next-line no-use-before-define
          $scope.timeout_idle = $timeout(timeoutIdleExpired,
            ((IDLE_TIMEOUT / 1000) - seconds_since_last_move) * 1000);
        } else {
          // eslint: (Recursive, so can't help it)
          // eslint-disable-next-line no-use-before-define
          $scope.timeout_idle = $timeout(timeoutIdleExpired, IDLE_TIMEOUT);
        }
      }

      function showCountdownAndLogout() {
        ///////////////////////////////////////////////////
        /// user must click OK, otherwise will be logged out
        ///////////////////////////////////////////////////
        $scope.countdown_initial = COUNTDOWN_TIMEOUT;
        $scope.countdown = $scope.countdown_initial;

        $scope.countdown_timer = $interval(function () {
          $scope.countdown = $scope.countdown - INTERVAL_IN_SECONDS;

          // check if OK clicked in some other tab
          let last_click_ok = persistentService.getLocalStorageObject('idle_last_click_ok');
          let seconds_since_last_ok = null;
          if (last_click_ok) {
            last_click_ok = new Date(parseInt(last_click_ok, 10));
            seconds_since_last_ok = (new Date().getTime() - last_click_ok.getTime()) / 1000;
          }

          if (seconds_since_last_ok && seconds_since_last_ok < COUNTDOWN_TIMEOUT) {
            // close this popup, because OK was clicked in some other tab
            if ($scope.idlePopup) {
              $scope.idlePopup.close();
              $scope.idlePopup = null;
            }
            cancelCountdown();
            resetIdleTimeout();
            return;
          }

          // hasSession(), not getMyDetails(): the question here is whether anybody is still signed
          // in, and a session refused for belonging to another sub-app is still a session. Reading
          // the refusal as "logged out in some other tab" logs the user out on the first idle tick
          // (RPR-6770).
          if ($scope.countdown <= 0 || !authHelper.hasSession()) {
            // countdown expired or user logged out in some other tab
            cancelCountdown();
            authHelper.doLogoutAll(true);
          }
        }, (INTERVAL_IN_SECONDS * 1000) );

        $scope.idlePopup = $ngConfirm({
          'title': 'You\'re Idle.',
          'contentUrl': '../' + 'html_templates/dialogs/idle_popup.565782b6.html',
          'type': 'orange',
          'scope': $scope,
          'buttons': {
            'OK': {
              btnClass: 'mat ui primary button',
              action: function (scope, button) {
                cancelCountdown();
                resetIdleTimeout();

                persistentService.saveLocalStorageObject(
                  '' + new Date().getTime(),
                  'idle_last_click_ok'
                );
              }
            }
          }
        });
      }

      function timeoutIdleExpired() {
        let last_move_time = persistentService.getLocalStorageObject('idle_last_move');
        let seconds_since_last_move = null;

        if (last_move_time) {
          last_move_time = new Date(parseInt(last_move_time, 10));
          seconds_since_last_move = (new Date().getTime() - last_move_time.getTime()) / 1000;
        }

        if (seconds_since_last_move && seconds_since_last_move < IDLE_TIMEOUT / 1000) {
          // reset timeout again
          resetIdleTimeout(seconds_since_last_move);
          return;
        }

        // log user out
        if (!$scope.idle_countdown_timer) {
          showCountdownAndLogout();
        }
      }

      let last_recorded_time = new Date();

      function mouseMoveRecord(e) {
        // do not record more often than 1 second
        if ((new Date().getTime() - last_recorded_time.getTime()) / 1000 > 1) {
          last_recorded_time = new Date();

          persistentService.saveLocalStorageObject(
            '' + last_recorded_time.getTime(),
            'idle_last_move'
          );
        }
      }
      // used in header_*.html files to execute their controller methods only when logged in
      // Via authHelper so a session that cannot belong to this sub-app reads as "not logged in"
      // rather than driving the header off someone else's session (RPR-6770).
      //
      // Returns a boolean, where the pre-RPR-6770 version returned the raw `string|null` from
      // sessionStorage. Only ever consumed by ng-if, so the coercion is not a behaviour change --
      // but it is the rot-prone part if a future caller wants the value rather than the truthiness.
      //
      // getCachedLoginDetails memoizes on the stored string, which is what makes this safe to call
      // from an ng-if: it runs on every digest, and digests loop until stable.
      $scope.is_logged_in = function() {
        return !!authHelper.getCachedLoginDetails();
      };

      // set these definitions outside isLoggedIn, as some times these definitions
      // are not available in admin_header_controller, in any controller we call portalReady
      // before using or loading data to make use we have user permission before we
      // invoke these functions
      $rootScope.PERMISSIONS = CONSTANTS.getPermissions();
      $rootScope.has_permission = permissionsHelper.hasPermission;
      $rootScope.has_any_of_permissions = permissionsHelper.hasAnyOfPermissions;
      $rootScope.has_all_of_permissions = permissionsHelper.hasAllOfPermissions;

      // RPR-6745: clean up any video upload abandoned by a page refresh / tab
      // close. The File handle can't survive a reload, so such an upload is dead;
      // retire its placeholder + abort the S3 multipart and warn the user. The
      // factory is only registered in the admin/client bundles, so resolve it
      // lazily and ignore its absence in other portals.
      function reapAbandonedVideoUploads() {
        let videoUploaderFactory = null;
        try {
          videoUploaderFactory = $injector.get('videoUploaderFactory');
        } catch {
          return; // video uploads not enabled in this portal bundle
        }
        if (!videoUploaderFactory || typeof videoUploaderFactory.reapInterruptedUploads !== 'function') {
          return;
        }
        videoUploaderFactory.reapInterruptedUploads().then(function (reaped) {
          if (!reaped?.length) { return; }
          const names = reaped.map(function (r) { return r.fileName; }).filter(Boolean).join(', ');
          const many = reaped.length > 1;
          portalHelper.showToast(
            'warning',
            'Your video upload' + (many ? 's' : '') + (names ? ' (' + names + ')' : '') + ' ' +
            (many ? 'were' : 'was') + ' cancelled because the page was reloaded. Please upload again.',
            'Upload cancelled'
          );
        });
      }

      authHelper.isLoggedIn().then(
        function (result)  {

          portalHelper.portalReady(function () {
            reapAbandonedVideoUploads();
            persistentService.ready(function () {
              // Start idle timeout
              $scope.timeout_idle = $timeout(timeoutIdleExpired, IDLE_TIMEOUT);
              const bodyElement = angular.element($document);

              angular.forEach(['keydown', 'keyup', 'click', 'mousemove', 'DOMMouseScroll', 'mousewheel',
                'mousedown', 'touchstart', 'touchmove', 'scroll', 'focus'], function (EventName) {
                bodyElement.bind(EventName, function (e) {
                  mouseMoveRecord(e);
                });
              });
              //
              // end track idle users
              //
            });
          });
        },
        function () {
          // TODO: Send to backend login page with redirect to current page
        }
      );
    }]
);
